import { createSelector } from '@reduxjs/toolkit';
import { getLocations } from './getLocations';

export const locationsListSelector = createSelector(getLocations, state => state.list);
export const locationsHashSelector = createSelector(getLocations, state => state.hash);
